import CustomFilterSelect from "./CustomFilterSelect";

const FilterDateLast12Months = (props: any) => {
  const { source, label, variant } = props;
  let DateFilterData = [];
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1; // 1-12
  DateFilterData.push({
    id: `${currentYear}-${currentMonth.toString().padStart(2, "0")}`,
    name: "Current Month",
  });
  for (let month = currentMonth - 1; month >= 1; month--) {
    const monthName = new Date(currentYear, month - 1).toLocaleString("en-US", {
      month: "long",
    });
    DateFilterData.push({
      id: `${currentYear}-${month.toString().padStart(2, "0")}`,
      name: `${monthName}`,
    });
  }
  DateFilterData.push({ id: "last_years_ago", name: "≥ 1 Year Ago" });

  return (
    <CustomFilterSelect
      source={source}
      label={label}
      choices={DateFilterData}
      before={props?.before != null && props.before !== "" ? props.before : ""}
    />
  );
};

export default FilterDateLast12Months;
